import React from "react";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const CompareResult = ({ r }) => (
  <div className="space-y-3 text-sm" data-testid="tabs-compare-result">
    <p className="font-semibold text-slate-800" data-testid="tabs-compare-summary">
      {r.compared} students compared (monthly fees up to {r.upto}) · <span className="text-green-700">{r.same} same</span> · <span className={r.different.length ? "text-red-700" : "text-green-700"}>{r.different.length} different</span>
    </p>
    {r.different.length > 0 && (
      <div className="overflow-x-auto">
        <table className="text-xs border-collapse min-w-full">
          <thead><tr>{["Student", "Sheet place", "Sheet balance", "App balance", "Difference", "Why (sheet / app)"].map((h) => <th key={h} className="border border-slate-200 bg-slate-50 px-2 py-1 text-left">{h}</th>)}</tr></thead>
          <tbody>{r.different.map((d) => (
            <tr key={d.roll} data-testid={`tabs-compare-row-${d.roll}`}>
              <td className="border border-slate-200 px-2 py-1 font-medium">{d.name} · {d.roll}<div className="text-slate-400">{d.class} · {d.kind === "lump" ? "lump-sum" : "monthly"}</div></td>
              <td className="border border-slate-200 px-2 py-1">{d.place}</td>
              <td className="border border-slate-200 px-2 py-1">{inr(d.sheet_balance)}</td>
              <td className="border border-slate-200 px-2 py-1">{inr(d.app_balance)}</td>
              <td className={`border border-slate-200 px-2 py-1 font-semibold ${d.difference > 0 ? "text-red-700" : "text-amber-700"}`}>{d.difference > 0 ? `App ${inr(d.difference)} more` : `App ${inr(-d.difference)} less`}</td>
              <td className="border border-slate-200 px-2 py-1 text-slate-600">Sheet: {d.sheet_detail}<br />App: {d.app_detail || "nothing unpaid"}{d.pending_in_app > 0 && <span className="text-blue-700"> · {d.pending_in_app} payment waiting in Pending Approvals</span>}</td>
            </tr>))}</tbody>
        </table>
      </div>
    )}
    {r.problems.length > 0 && (
      <details className="rounded-lg border border-amber-200 bg-amber-50 p-2 text-xs text-amber-900" data-testid="tabs-compare-problems">
        <summary className="cursor-pointer font-semibold">Could not compare — {r.problems.length}</summary>
        <ul className="mt-1 list-disc pl-5 max-h-48 overflow-y-auto">{r.problems.map((p) => <li key={p.roll + p.place}>{p.roll} {p.name || ""} ({p.place}): {p.reason}</li>)}</ul>
      </details>
    )}
    <p className="text-[11px] text-slate-500">Read only — nothing was changed. To fix, open the student in Fees and use "Already paid" or "Correct payment", or correct the sheet.</p>
  </div>
);
